import { AppStateProvider } from 'src/app/services/app-state.provider';
import { Router } from '@angular/router';
import { NotificationService } from 'src/app/services/notification.service';
import { NotificationModel } from './../../model/Notification.model';
import { Component, AfterViewInit } from '@angular/core';
import { AppConstant } from 'src/app/config/app.constant';

@Component({
  standalone: false,
  selector: 'notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
})
export class NotificationsComponent implements AfterViewInit {
  isNew: boolean = true;
  notifications: NotificationModel[] = [];
  allNotifications: NotificationModel[] = [];
  modifiedNotifications: { date: string; notification: NotificationModel[] }[] =
    [];
  newNotificationCount: number = 0;
  constructor(
    private appStateSrv: AppStateProvider,
    private notificationSrv: NotificationService,
    private router: Router
  ) {
    // this.appStateSrv.toggleNotificationsDrawer(true)
  }

  ngAfterViewInit() {
    this.closeDrawer();
    this.appStateSrv.getNotificationDrawerState().subscribe((state) => {
      // console.log('subscribed with ', state);
      if (state !== null)
        if (state) {
          this.openDrawer();
        } else {
          // console.log('closing');
          this.makeNotificationsAsRead();
          this.closeDrawer();
        }
    });
  }

  makeNotificationsAsRead() {
    const payload = {
      id: null,
      userId: localStorage.getItem(AppConstant.localStorage.userId),
      isNew: false,
    };
    this.notificationSrv.updateAllNotifications(payload).subscribe();
  }

  ngOnInit() {
    this.dummyNotifications();
    this.notificationSrv
      .getSavedNotifications()
      .subscribe((notifications: NotificationModel[]) => {
        // console.log('notifications', notifications);
        this.allNotifications = notifications;
        this.prepareNotificationList();
      });
  }

  prepareNotificationList() {
    const months = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];
    let formatDate = (date) => {
      const newDate = new Date(date);
      if (date.split('T')[0] == new Date().toISOString().split('T')[0])
        return (
          'Today, ' +
          ('0' + Number(newDate.getDate())).slice(-2) +
          ' ' +
          months[newDate.getMonth()]
        );
      else
        return (
          ('0' + Number(newDate.getDate())).slice(-2) +
          ' ' +
          months[newDate.getMonth()]
        );
    };

    let notifications: { date: string; notification: NotificationModel[] }[] =
      [];
    let date = null;
    let temp: { date: string; notification: NotificationModel[] } = {
      date: '',
      notification: [],
    };
    this.allNotifications.forEach((notification) => {
      if (date !== notification.createdDate.split('T')[0]) {
        notifications.push(temp);
        date = notification.createdDate.split('T')[0];
        temp.date = formatDate(notification.createdDate);
        temp.notification.push(notification);
      } else {
        temp.notification.push(notification);
      }
    });
    // console.log('notifications modified', notifications);
    this.modifiedNotifications = notifications;
    this.newNotificationCount = 0;
    this.modifiedNotifications.forEach((notifications) => {
      notifications.notification.forEach((notify) => {
        if (notify.isNew) this.newNotificationCount++;
      });
    });
  }

  getTimeFromISO(date) {
    const time = date.match(/\d\d:\d\d/)[0];
    let hrs = Number(time.split(':')[0]);
    let mins = Number(time.split(':')[1]);
    let type = 'AM';
    if (Number(time.split(':')[0]) > 12) hrs = Number(time.split(':')[0]) - 12;
    if (Number(time.split(':')[0]) >= 12) type = 'PM';
    return ('0' + hrs).slice(-2) + ':' + ('0' + mins).slice(-2) + ' ' + type;
  }

  dummyNotifications() {
    this.notifications = [
      {
        id: 0,
        userId: 100,
        title: 'First Notification',
        message:
          'First Notification content Lorem ipsum dolor sit a fsdfsd sdfgdfg',
        createdDate: '25th April',
        isNew: true,
      },
      {
        id: 0,
        userId: 100,
        title: 'Second Notification',
        message:
          'Second Notification content Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor',
        createdDate: '25th April',
        isNew: false,
      },
      {
        id: 0,
        userId: 100,
        title: 'Third Notification',
        message:
          'Third Notification content Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor',
        createdDate: '25th April',
        isNew: false,
      },
    ];
  }

  closeDrawer() {
    // console.log('closed');

    document
      .getElementById('notification-backdrop')
      .classList.remove('backdrop');
    document.getElementById('notifications').style.right = '-30%';
    document.getElementById('notifications').style.transition =
      '0.3s ease-in-out';
  }

  openDrawer() {
    // console.log('opened');
    document.getElementById('notification-backdrop').classList.add('backdrop');
    document.getElementById('notifications').style.right = '0%';
    document.getElementById('notifications').style.transition =
      '0.3s ease-in-out';
  }

  backdropClick(e) {
    if (e.target.id == 'notification-backdrop')
      this.appStateSrv.toggleNotificationsDrawer(false);
  }

  notificationClickHandler(notification) {
    // console.log('notification', notification);
    switch (notification.pageNavig) {
      case 1:
        this.router.navigate(['/overview']);
        break;
      case 2:
        this.router.navigate(['/employees/employees-list']);
        break;
      case 3:
        this.router.navigate(['/meeting/meetingroom-list']);
        break;
      case 4:
        this.router.navigate(['/credits']);
        break;
      case 5:
        this.router.navigate(['/reports']);
        break;
      case 6:
        this.router.navigate(['/contact']);
        break;
      case 7:
        this.router.navigate(['/companies/companies-list']);
        break;
    }
    this.appStateSrv.toggleNotificationsDrawer(false);
    const payLoad = {
      id: notification.id,
      tenantId: 0,
    };
    this.notificationSrv.clearNotification(payLoad).subscribe();
  }

  clearAllNotification() {
    const payLoad = {
      id: null,
      tenantId: 0,
    };
    this.notificationSrv.clearNotification(payLoad).subscribe();
    this.appStateSrv.toggleNotificationsDrawer(false);
  }
}
